import { useFetch } from '../../../hooks';
import { getShortAgents, getTelephony } from '../../../api';
import { getInboundListForOrganization } from '../../../api';
import type { InboundTelephonyListItemType } from '../../../api';

export type ListItemType = InboundTelephonyListItemType;

export const useInbound = () => {
  const { data, intializing: loading } = useFetch(
    () => getInboundListForOrganization(),
    []
  );
  const { data: telephony, intializing: loadingTelephony } = useFetch(
    () => getTelephony(),
    []
  );
  const { data: agents, intializing: loadingAgents } = useFetch(
    () => getShortAgents(),
    []
  );

  return {
    data: data || [],
    sipTrunkName: telephony?.integrationName || '',
    agentsMap: new Map(agents?.map?.(a => [a.id, a.title]) || []),

    loading: loading || loadingAgents || loadingTelephony,
  };
};
